// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2c72d0b3","171":"415ea3ed","265":"66803e4e","333":"37a855fc","453":"cc4fd38e","655":"5a644336"}[chunkId] + ".chunk.js";
};